import { Pipe, PipeTransform } from '@angular/core';

import { LanguageService } from '../services/language.service';

@Pipe({
  name: 'pepDate',
})
export class PepDatePipe implements PipeTransform {
  constructor(public languageService: LanguageService) {}

  transform(value: Date, locale?: string, time = false, tz?: string): any {
    if (!value) {
      return value;
    }
    const options: any = {};

    if (time) {
      options.day = 'numeric';
      options.month = 'numeric';
      options.year = 'numeric';
      options.hour = 'numeric';
      options.minute = 'numeric';

      // Our tz not compatable with Intl's, convert value before returning from API
      if (tz) {
        options.timeZone = tz;
      }
    }

    return this.languageService.formatDate(value, locale, options);
  }
}
